import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';

const ContentTypeChart = ({ stats }) => {
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Content Type Distribution
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Breakdown between template validation and execution input checks
        </Typography>
        <Box height={300}>
          <Chart
            options={{
              chart: {
                type: 'pie',
              },
              labels: stats?.distributionStats?.map(item => item.name) || [],
              colors:
                stats?.distributionStats?.map((item, index) => {
                  const colorMap = [
                    theme.palette.primary?.main || '#2196f3',
                    theme.palette.secondary?.main || '#9c27b0',
                  ];
                  return colorMap[index % colorMap.length];
                }) || [],
              legend: {
                position: 'bottom',
              },
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200,
                    },
                    legend: {
                      position: 'bottom',
                    },
                  },
                },
              ],
            }}
            series={stats?.distributionStats?.map(item => item.value) || []}
            type="pie"
            height={300}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ContentTypeChart;
